import { render } from "./Landing.vue?vue&type=template&id=9a52cf8e&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "../../../assets/css/landing.css?vue&type=style&index=0&id=9a52cf8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9a52cf8e"

export default script